import { RealtimeClient } from "./RealtimeClient";
import { RestClient } from "./restClient";

export class BRCService {
	constructor(options) {
		this._options = options;
		this._restClient = new RestClient();
		this._rc = new RealtimeClient();
	}

	/**
	 * streamRecommendations
	 * stream all recommendations for given activity
	 */
	streamRecommendations(activityId, callback) {
		const args = { activityId };
		return this._rc.subscribe("brc-app", "/recommendations", args, (msg) => {
			const response = JSON.parse(msg);
			if (response && callback) {
				callback(null, response);
			}
		});
	}

	/**
	 * getRecommendationsByActivityId
	 * returns array of recommendations matching given activityId
	 */
	getRecommendationsByActivityId(activityId, callback) {
		const url = `/brc-app/api/recommendations?activityId=${activityId}`;
		this._restClient.exec_get(url, callback);
	}

	/**
	 * getRecommendationsByUnitId
	 * returns array of recommendations matching given unitId
	 */
	getRecommendationsByUnitId(unitId, callback) {
		const url = `/brc-app/api/recommendations?unitId=${unitId}`;
		this._restClient.exec_get(url, callback);
	}

	/**
	 * notifyRecommendations - sends an sms dispatch notification to unit members associated with the recommendation
	 * returns array of recommendationIds to notify on
	 */
	notifyRecommendations(recommendationIds, callback) {
		const url = "/brc-app/api/recommendations/notify";
		const body = JSON.stringify({ recommendationIds });
		this._restClient.exec_post(url, body, callback);
	}

	/**
	 * getDetections
	 * returns array of detections starting at X seconds before startDate
	 */
	getDetections(startDate, timeDelta, callback) {
		const url = `/brc-app/api/detections?startDate=${startDate}&timeDelta=${timeDelta}`;
		this._restClient.exec_get(url, callback);
	}
}
